import { render } from "./LearningGroupEditingPage.vue?vue&type=template&id=ae791972&scoped=true"
import script from "./LearningGroupEditingPage.vue?vue&type=script&lang=js"
export * from "./LearningGroupEditingPage.vue?vue&type=script&lang=js"

import "./LearningGroupEditingPage.vue?vue&type=style&index=0&id=ae791972&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae791972"]])

export default __exports__